import {
  AbilitySubject,
  AbilitySubjectType,
  IBaseModel,
  IBaseModelWoId,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export abstract class BaseModelWoId<
  T = unknown,
  Kind extends AbilitySubject = AbilitySubject,
> implements IBaseModelWoId<Kind>
{
  get kind() {
    return ((this.constructor as typeof BaseModelWoId).modelName ??
      'all') as Kind;
  }

  /*
   * Model name is required to determine the kind of model when checking permissions with CASL.
   */
  static readonly modelName: AbilitySubjectType;

  @Type(() => Date)
  createdAt!: Date;

  @Type(() => Date)
  updatedAt!: Date;

  @Type(() => String)
  updatedBy: string | null = null;

  @Type(() => String)
  createdBy: string | null = null;

  constructor(data: Partial<T>) {
    Object.assign(this, data);
  }
}

export abstract class BaseModel<
    T = unknown,
    Kind extends AbilitySubject = AbilitySubject,
  >
  extends BaseModelWoId<T, Kind>
  implements IBaseModel<Kind>
{
  id!: string;
}
